import Swiper from 'swiper/bundle';
import ProductPopup from "../modules/ProductPopup";
import AjaxAddToCart from "../modules/AjaxAddToCart";

export default {
  init() {

    new AjaxAddToCart();

    const recommendedProducts = document.querySelector('#recommended-products');

    if ( recommendedProducts ) {
      const count = recommendedProducts.querySelectorAll('.swiper-slide').length;
      new Swiper(recommendedProducts, {
        slidesPerView: 'auto',
        spaceBetween: 12,
        autoHeight: false,
        enabled: count > 1,
        centeredSlides: count > 1,
        loop: count > 1,
        grabCursor: true,
        on: {
          breakpoint: function(swiper, breakpointParams) {
            if(!breakpointParams.enabled) {
              swiper.$el[0].classList.add('product-slider-disabled');
            } else {
              swiper.$el[0].classList.remove('product-slider-disabled');
            }
          },
        },
        breakpoints: {
          360: {
            enabled: count > 2,
            centeredSlides: count > 2,
            loop: count > 2,
          },
          510: {
            enabled: count > 3,
            centeredSlides: count > 3,
            loop: count > 3,
          },
          992: {
            spaceBetween: 30,
            enabled: count > 4,
            centeredSlides: count > 4,
            loop: count > 4,
            navigation: {
              nextEl: '.swiper-button-next',
              prevEl: '.swiper-button-prev',
            },
          },
          2000 : {
            enabled: count > 6,
            centeredSlides: count > 6,
            loop: count > 6,
          },
        },
      })

      new ProductPopup();
    }
  },
  finalize() {
    // JavaScript to be fired on all pages, after page specific JS is fired
  },
};
